// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3iH60","spinner":"Tabs_spinner__1HS5A"};